import React from "react";
import { useAppContext } from "../../helpers/account-context";

import { toPermalink, ICONS } from "../../helpers/helper";

const ActionButton = (props) => {
  const { name, icon, url} = props;
  return (
    <a
    className={`cbmap-btn cbmap-btn-outline cbmap-btn_${toPermalink(name)}`}
    href={url}
    target={`_blank`}
  >
    <span
      className="cbmap-icon"
      dangerouslySetInnerHTML={{
        __html: icon,
      }}
    />
    {name}
  </a>    
  )
}

export const ActionsDetail = (props) => {
  const { getLocale} = useAppContext()
  const {
    item,
  } = props;

  const directionUrl = `https://www.google.com/maps/dir/?api=1&destination=${item.properties.address}`;
  return (
    <div className="cbmap-details-prop cbmap-details_actions">
      <ActionButton
        name={getLocale('directions')}
        url={directionUrl}
        icon={ICONS.COMPASS}
      />
     
      {item.properties.phone && item.properties.phone.length > 0 && (
         <ActionButton
         name={getLocale('call')}
         url={`tel:${item.properties.phone}`}
         icon={ICONS.SMARTPHONE}
       />
       
      )}
      
      {item.properties.email && item.properties.email.length > 0 && (
         <ActionButton
         name={getLocale('email')}
         url={`mailto:${item.properties.email}`}
         icon={ICONS.EMAIL}
       />
       
      )}

      {item.properties.url && item.properties.url.length > 0 && (
          <ActionButton
          name={getLocale('website')}
          url={`${item.properties.url}`}
          icon={ICONS.GLOBE}
        />

       
      )}
    </div>
  );
};

export const ActionsInfowin = (props) => {
  const { getLocale} = useAppContext()

  const {
    item,
  } = props;

  const directionUrl = `https://www.google.com/maps/dir/?api=1&destination=${item.properties.address}`;
  return (
    <div className="cbmap-infowin-row cbmap-infowin_actions">
      <ActionButton
        name={getLocale('directions')}
        url={directionUrl}
        icon={ICONS.COMPASS}
      />
     
      {item.properties.phone && item.properties.phone.length > 0 && (
         <ActionButton
         name={getLocale('call')}
         url={`tel:${item.properties.phone}`}
         icon={ICONS.SMARTPHONE}
       />
       
      )}
      
      {item.properties.email && item.properties.email.length > 0 && (
         <ActionButton
         name={getLocale('email')}
         url={`mailto:${item.properties.email}`}
         icon={ICONS.EMAIL}
       />
       
      )}

      {item.properties.url && item.properties.url.length > 0 && (
          <ActionButton
          name={getLocale('website')}
          url={`${item.properties.url}`}
          icon={ICONS.GLOBE}
        />
       
      )}
    </div>
  );
};

